import { fromJS } from 'immutable';

import * as actionTypes from './actionTypes';
import { IRequestStatus } from '../../declarations';

export const initialState = fromJS({
  info: {},
  infoError: undefined,
  infoIsLoaded: false,
  infoIsLoading: true,
  loginRequestStatus: { error: undefined, isLoading: false } as IRequestStatus,
  humanStatusRequestStatus: { error: undefined, isLoading: false } as IRequestStatus,
  registrationRequestStatus: { error: undefined, isLoading: false } as IRequestStatus,
  resetPasswordRequestStatus: { error: undefined, isLoading: false } as IRequestStatus,
  serverLoginRedirect: undefined,
  email: '',
  hasGeneratedPassword: undefined,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.BEGIN_LOADING_SESSION_INFO:
      return state.merge({
        infoError: undefined,
        infoIsLoading: true,
      });
    case actionTypes.RECEIVE_SESSION_INFO:
      return state.merge({
        info: fromJS(action.payload.info),
        infoError: undefined,
        infoIsLoaded: true,
        infoIsLoading: false,
      });
    case actionTypes.ERROR_SESSION_INFO:
      return state.merge({
        infoError: action.payload.error,
        infoIsLoading: false,
      });
    case actionTypes.BEGIN_LOG_IN:
      return state.merge({
        loginRequestStatus: { error: undefined, isLoading: true },
      });
    case actionTypes.SUCCESS_LOG_IN:
      return state.merge({
        loginRequestStatus: { error: undefined, isLoading: false },
        serverLoginRedirect: action.payload.serverLoginRedirect,
      });
    case actionTypes.ERROR_LOG_IN:
      return state.merge({
        loginRequestStatus: {
          error: action.payload.error,
          statusCode: action.payload.statusCode,
          isLoading: false,
        },
      });
    case actionTypes.BEGIN_REQUEST_HUMAN_STATUS:
      return state.merge({
        humanStatusRequestStatus: { error: undefined, isLoading: true },
      });
    case actionTypes.SUCCESS_REQUEST_HUMAN_STATUS:
      return state.merge({
        humanStatusRequestStatus: { error: undefined, isLoading: false },
        email: action.payload.email,
        hasGeneratedPassword: action.payload.hasGeneratedPassword,
        isNewHuman: action.payload.isNewHuman,
      });
    case actionTypes.ERROR_REQUEST_HUMAN_STATUS:
      return state.merge({
        humanStatusRequestStatus: {
          error: action.payload.error,
          statusCode: action.payload.statusCode,
          isLoading: false,
        },
        email: action.payload.email,
        hasGeneratedPassword: false,
      });
    case actionTypes.BEGIN_REQUEST_RESET_PASSWORD:
      return state.merge({
        resetPasswordRequestStatus: { error: undefined, isLoading: true },
      });
    case actionTypes.SUCCESS_REQUEST_RESET_PASSWORD:
      return state.merge({
        resetPasswordRequestStatus: { error: undefined, isLoading: false },
        email: action.payload.email,
        hasGeneratedPassword: action.payload.hasGeneratedPassword,
        isNewHuman: action.payload.isNewHuman,
      });
    case actionTypes.ERROR_REQUEST_RESET_PASSWORD:
      return state.merge({
        resetPasswordRequestStatus: {
          error: action.payload.error,
          statusCode: action.payload.statusCode,
          isLoading: false,
        },
        email: action.payload.email,
        hasGeneratedPassword: false,
      });
    case actionTypes.BEGIN_REGISTER:
      return state.merge({
        registrationRequestStatus: { error: undefined, isLoading: true },
      });
    case actionTypes.SUCCESS_REGISTER:
      return state.merge({
        registrationRequestStatus: {
          error: undefined,
          isLoading: false,
          success: true,
        },
      });
    case actionTypes.ERROR_REGISTER:
      return state.merge({
        registrationRequestStatus: { error: action.payload.error, isLoading: false },
      });
    case actionTypes.MAYBE_LOG_OUT:
      return state.merge({
        infoIsLoading: true,
      });
    case actionTypes.LOGGED_OUT:
      return state.merge({
        info: { logged_in: false },
        infoError: undefined,
        infoIsLoaded: true,
        infoIsLoading: false,
      });
    default:
      return state;
  }
}
